import React, {memo} from 'react';
import {styled} from '@mui/material/styles';
import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import LaunchIcon from '@mui/icons-material/Launch';
import Typography from '@mui/material/Typography';
import {green} from '@mui/material/colors';
import classNames from 'classnames';

const Root = styled(MuiDialogTitle)(({theme}) => ({
   margin: 0,
   padding: theme.spacing(2),
   color: '#fff',
   backgroundColor: green[500],
   position: 'relative',
}));

const RightButtonSection = styled('div')(({theme}) => ({
   position: 'absolute',
   top: theme.spacing(1),
   right: theme.spacing(1),
}));

export type DialogTitleProps = {
   id: string;
   children: React.ReactNode;
   className?: string;
   onClose?: () => void;
   onLaunch?: () => void;
};

export const DialogTitle = memo(
   ({children, onClose, onLaunch, className, ...other}: DialogTitleProps) => {
      return (
         <Root className={classNames(className)} {...other}>
            <Typography variant="h6" component="span">
               {children}
            </Typography>

            <RightButtonSection>
               {onLaunch && (
                  <IconButton
                     aria-label="launch"
                     onClick={onLaunch}
                     size="large"
                     sx={{color: '#fff'}}
                  >
                     <LaunchIcon />
                  </IconButton>
               )}

               {onClose && (
                  <IconButton
                     aria-label="close"
                     onClick={onClose}
                     size="large"
                     sx={{color: '#fff'}}
                  >
                     <CloseIcon />
                  </IconButton>
               )}
            </RightButtonSection>
         </Root>
      );
   }
);
